import { ColorSystemOptions } from '@mui/material/styles';
import { colors } from '../variables/colors';

export const darkTheme: ColorSystemOptions = {
  palette: {
    mode: 'dark',
    ...colors,
    common: {
      black: colors.black,
      white: colors.white,
    },
    primary: {
      ...colors.lightGreen,
      main: colors.lightGreen[600],
      light: colors.lightGreen[200],
      contrastText: colors.white,
    },
    secondary: {
      main: colors.orange[500],
    },
    error: {
      main: colors.red[500],
    },
    background: {
      default: colors.black,
      paper: colors.grey[800],
    },
    text: {
      primary: colors.white,
      secondary: colors.grey[300],
    },
  },
};
